<small *ngIf="field.content">{{ field.content }}</small>
<small i18n *ngIf="!field.content">Empty</small>
